/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, oneOf as codecOneOf, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AssignmentAnonymizationAlgo } from './AssignmentAnonymizationAlgo';
import { AssignmentDoneType } from './AssignmentDoneType';
import { AssignmentKind } from './AssignmentKind';
import { AssignmentPercentageGradingSettings } from './AssignmentPercentageGradingSettings';
import { AssignmentPointsGradingSettings } from './AssignmentPointsGradingSettings';
import { AssignmentSubmissionMode } from './AssignmentSubmissionMode';
import { FixedGradeAvailability } from './FixedGradeAvailability';
import { SubmissionValidatorInputData } from './SubmissionValidatorInputData';
const PatchAssignmentDataParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ codecOptional(codecString)],
    [
        'maxGrade',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecNumber)),
        'max_grade',
    ],
    [
        'groupSetId',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecNumber)),
        'group_set_id',
    ],
    [
        'sendLoginLinks',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'send_login_links',
    ],
    ['kind', /* #__PURE__ */ codecOptional(AssignmentKind)],
    [
        'filesUploadEnabled',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'files_upload_enabled',
    ],
    [
        'webhookUploadEnabled',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'webhook_upload_enabled',
    ],
    [
        'maxSubmissions',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecNumber)),
        'max_submissions',
    ],
    [
        'coolOffPeriod',
        /* #__PURE__ */ codecOptional(codecNumber),
        'cool_off_period',
    ],
    [
        'amountInCoolOffPeriod',
        /* #__PURE__ */ codecOptional(codecNumber),
        'amount_in_cool_off_period',
    ],
    [
        'ignore',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ codecOneOf([SubmissionValidatorInputData, codecString])),
    ],
    [
        'ignoreVersion',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('EmptySubmissionFilter', 'IgnoreFilterManager', 'SubmissionValidator')),
        'ignore_version',
    ],
    [
        'doneType',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.maybeNull(AssignmentDoneType)),
        'done_type',
    ],
    [
        'reminderTime',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(parsers.moment)),
        'reminder_time',
    ],
    [
        'doneEmail',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecString)),
        'done_email',
    ],
    [
        'anonymizedGrading',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.maybeNull(AssignmentAnonymizationAlgo)),
        'anonymized_grading',
    ],
    [
        'fileToLoadFirst',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecString)),
        'file_to_load_first',
    ],
    [
        'grading',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.taggedUnion('scale', [
            ['percentage', AssignmentPercentageGradingSettings],
            ['points', AssignmentPointsGradingSettings],
        ])),
    ],
    [
        'gradeAvailability',
        /* #__PURE__ */ codecOptional(FixedGradeAvailability),
        'grade_availability',
    ],
    [
        'submissionMode',
        /* #__PURE__ */ codecOptional(AssignmentSubmissionMode),
        'submission_mode',
    ],
]));
export class PatchAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchAssignmentDataParser.decode(input).map(res => new PatchAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PatchAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchAssignmentDataParser.encode(data);
    }
    static schema() {
        return PatchAssignmentDataParser.schema();
    }
}
